import { render, staticRenderFns } from "./TeamViewHeaderLogo.vue?vue&type=template&id=0d77aea7&"
import script from "./TeamViewHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./TeamViewHeaderLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports